export default __webpack_public_path__ + "static/media/grata_result.png";